import { updatePromoVV, updateVV } from "@/helpers/api/service/Video";
import debounce from "lodash/debounce";

export const getNextAd = (currentAds: any) => {
  const nextAdIndex = currentAds.findIndex((ad: { state: any; adType: string; }) => !ad.state);
  if (nextAdIndex === -1 || !currentAds[nextAdIndex]) {
    return;
  }
  return { index: nextAdIndex, adType: currentAds[nextAdIndex].adType, adToPlay: currentAds[nextAdIndex] }
}

export const debouncedUpdateVV = () => debounce(updateVV, 2000, {
  leading: true,
  trailing: false,
});

export const debouncedUpdatePromoVV = () => debounce(updatePromoVV, 2000, {
  leading: true,
  trailing: false,
});

export const checkETData = (videoData: any) => {
  return !!(videoData?.answer_id && videoData?.question_id)
}
